<template>
  <div class="child-visitation-wrapper" v-if="visitations.length !== 0" :id="date">
    <div v-for="(visitation, i) in visitations" :key="i">
      <div
        class="child-visitation"
        :class="{'last-visitation' : visitation.end === 1, 'last-blanc-visitation' : isLastBlancVisitation(visitation) }"
        :style="{'border': '12px solid ' + visitation.color}"
      >
      </div>
      <span
        v-show="visitation.start === 1"
        class="text"
        :style="{
          'text-overflow': 'ellipsis',
          'width': calculateWidth(visitation) + 'px',
        }"
        :title="visitation.summary"
      >
        {{ visitation.summary }}
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    name: "FPCalendarSingleEvents",
    props: {
      visitations: {
        type: Array,
        required: true,
        default: () => []
      },
      date: {
        type: String,
        required: true,
        default: () => ''
      }
    },
    data() {
      return {
        blockWidth: 0
      }
    },
    mounted() {
      this.blockWidth = document.getElementsByClassName('day')[0].offsetWidth;
      window.addEventListener('resize', this.handleBoxResize)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleBoxResize)
    },
    methods: {
      handleBoxResize() {
        this.blockWidth = document.getElementsByClassName('day')[0].offsetWidth
      },
      calculateWidth(visitation) {
        if (visitation.length <= 7) {
          return visitation.length * this.blockWidth
        } else {
          return 7 * this.blockWidth
        }
      },
      isLastBlancVisitation(vistation) {
        let index = this.visitations.indexOf(vistation);
        return (index + 1) === this.visitations.length && vistation.length === 0;
      }
    }
  }
</script>
